import { Typography } from "@material-ui/core";
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom";
import api from "../api";

export default function MonitoringHasilLab(props) {
    const [listFacility, setListFacility] = useState([]);
    const history = useHistory();
    const [error, setError] = useState(false)

    useEffect(() => {
        getFacilityByID()
        props.setShowNotif(true)
    }, [])

    const getFacilityByID = () => {
        api.create().getFacilityByCategoriID("Laboratory").then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    setListFacility(response.data.data)
                }
            }
        })
    }

    const handleClick = (item) => {
        api.create().getSubFacilityByFacilityID(item.id).then(response => {
            if (response.data) {
                if (response.data.data.length > 0) {
                    history.push({
                        pathname: '/lab/hasil-lab',
                        name: 'Monitoring Hasil Lab',
                        search: '',  // query string
                        state: {  // location state
                            id: item.id,
                            nama: item.name
                        },
                    })
                } else {
                    setError(true)
                }
            }
        })
    }

    return (
        <div style={{  padding: 20, maxHeight: props.height - 90, overflow: 'scroll' }}>
            <div>
                <Typography style={{ color: '#333333', fontSize: 24, fontWeight: 'bold' }}>Pilih Fasilitas !</Typography>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 20, flexWrap: 'wrap' }}>
                {listFacility.map((item, index) => (
                    <div style={{ width: 400, padding: 20, borderRadius: 20, margin: '20px 0px', cursor: 'pointer', boxShadow: '5px 5px 10px 0 #999999' }}
                        onClick={() => handleClick(item)}
                    >
                        <div style={{ display: 'flex' }}>
                            <Typography style={{ color: '#333333', fontSize: 18, fontWeight: '500', fontFamily: 'Poppins' }}>{item.name}</Typography>
                        </div>
                        <div>
                            <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins' }}>{item.facility_location}</Typography>
                        </div>
                        <div>
                            <Typography style={{ color: '#333333', fontSize: 18, fontFamily: 'Poppins' }}>Lantai {item.floor}</Typography>
                        </div> 
                    </div>
                ))}
            </div>

            {error && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}> 
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>Anda harus menambahkan sub fasilitas pada fasilitas tersebut</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}> 
                                <div
                                    onClick={() => setError(false)}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}